module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputfield",
    class: _vm.cls
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.suffix) ? _c('div', {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.suffix))]) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('svgicon', {
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e46f8f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inputfield.vue
// module id = 579
// module chunks = 1